import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LanguageCode, TranslateService } from '@interticket/core';
import { IDropdownItem } from '../../interfaces/dropdown/dropdown-item.interface';

@Component({
  selector: 'lib-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePickerComponent {

  readonly supportedLangs: IDropdownItem[] = this.getSupportedLangs();
  readonly selectedLang: LanguageCode = this.translate.currentLang;

  constructor(
    private translate: TranslateService
  ) { }

  selectLanguage(lang: LanguageCode): void {
    if (!this.isCurrentLang(lang)) {
      this.translate.use(lang);
      location.reload();
    }
  }

  trackByFn(index: number): number {
    return index;
  }

  private getSupportedLangs(): IDropdownItem[] {
    return this.translate.supportedLangs
      .map((langCode) => ({
        value: langCode,
        label: 'lang_label_' + langCode,
        selected: this.isCurrentLang(langCode),
      }));
  }

  private isCurrentLang(lang: LanguageCode): boolean {
    return lang === this.translate.currentLang;
  }

}

